import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomSelectableDropdown from '@components/CustomSelectableDropdown';
import ModalContainer from '@components/modals/ModalContainer';

import { categoryTypeParamsBasedOnSupplier, filterFieldType } from '@features/filter/static/filterUtil';

import { storeInitialItemInGlobalFilter } from '@store/actions/FilterAction';

import { fetchDependentFilterList } from '@services/commonService';

import { getUserInfo } from '@utils/Util';

const QuickFilterSupplier = ({ onClose }) => {
	const [selectedSupplierType, setSelectedSupplierType] = useState([]);
	const [selectedFabricType, setSelectedFabricType] = useState([]);
	const [selectedProductCategory, setSelectedProductCategory] = useState([]);
	const [selectedCountry, setSelectedCountry] = useState([
		{ value: getUserInfo()?.country?.id, label: getUserInfo()?.country?.name }
	]);
	const [minPrice, setMinPrice] = useState('');
	const [maxPrice, setMaxPrice] = useState('');
	const [colorType, setColorType] = useState([]);
	const [brand, setBrand] = useState([]);
	const [errors, setErrors] = useState(null);
	const dispatch = useDispatch();
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const isLoading = useSelector((store) => store.loaderStore);
	// const filterfields = useSelector((store) => store.filterFieldStore);

	const onGetData = (data) => {
		let responseData = data?.map((item) => {
			return { value: item.constant || item.id, label: item.name };
		});
		return responseData;
	};

	useEffect(() => {
		dispatch(fetchDependentFilterList({ type: 'SUPPLIER_LIST' }, {}));
	}, []);

	// useEffect(() => {
	// 	for (let field in filterfields) {
	// 		if (filterfields[field]?.length > 0) {
	// 			let selectedList = filterfields[field];
	// 			let modifiedData = selectedList?.map((item) => ({ value: item.key, label: item.value }));
	// 			onSetSelectedFieldsFromStore(field, modifiedData);
	// 		}
	// 	}
	// }, [filterfields]);

	// const onSetSelectedFieldsFromStore = (type, data) => {
	// 	switch (type) {
	// 		case 'supplierType':
	// 			setSelectedSupplierType(data);
	// 			break;
	// 		case 'fabricTypeList':
	// 			setSelectedFabricType(data);
	// 			break;
	// 		case 'colorType':
	// 			setColorType(data);
	// 			break;
	// 		case 'productCategoryIds':
	// 			setSelectedProductCategory(data);
	// 			break;
	// 		case 'brandIds':
	// 			setBrand(data);
	// 			break;
	// 		default:
	// 			break;
	// 	}
	// };

	const isValidForm = () => {
		let newErrors = {};
		if (!selectedSupplierType?.length) {
			newErrors = { ...newErrors, typeError: 'Type is required' };
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const categoryTypeBasedOnSupplierType = {
		GARMENTS: 'categoryResponses',
		FABRIC: 'constructionResponseList',
		TRIMS: 'trimsCategoryTypeList',
		ACCESSORIES: 'accessoriesCategoryTypeList'
	};

	const handleSubmit = () => {
		const isValid = isValidForm();
		if (!isValid) {
			return;
		}
		const filteredState = {
			supplierType: selectedSupplierType?.map((item) => ({
				name: filterFieldType['SUPPLIER_TYPE']['idName'],
				key: item.value,
				value: item.label,
				identifier: `${filterFieldType['SUPPLIER_TYPE']['idName']}_${item.value}`,
				checked: true
			})),
			supplierCategoryList: selectedFabricType?.map((item) => ({
				name: filterFieldType['FABRIC_TYPE']['idName'],
				key: item.value,
				value: item.label,
				identifier: `${filterFieldType['FABRIC_TYPE']['idName']}_${item.value}`,
				checked: true
			})),
			[categoryTypeParamsBasedOnSupplier[selectedSupplierType[0]?.value]]: selectedProductCategory?.map(
				(item) => ({
					name: categoryTypeParamsBasedOnSupplier[selectedSupplierType[0]?.value],
					key: item.value,
					value: item.label,
					identifier: `${categoryTypeParamsBasedOnSupplier[selectedSupplierType[0]?.value]}_${
						item.value
					}`,
					checked: true
				})
			),
			colorType: colorType?.map((item) => ({
				name: filterFieldType['COLOR_TYPE']['idName'],
				key: item.value,
				value: item.label,
				identifier: `${filterFieldType['COLOR_TYPE']['idName']}_${item.value}`,
				checked: true
			})),
			brandIds: brand?.map((item) => ({
				name: filterFieldType['BRAND']['idName'],
				key: item.value,
				value: item.label,
				identifier: `${filterFieldType['BRAND']['idName']}_${item.value}`,
				checked: true
			})),
			countryId: selectedCountry?.map((item) => ({
				name: 'countryId',
				key: item.value,
				value: item.label,
				identifier: `countryId_${item.value}`
			})),
			minPrice: [
				{
					name: 'minPrice',
					key: minPrice,
					value: minPrice,
					identifier: `min_price_${minPrice}`
				}
			],
			maxPrice: [
				{
					name: 'maxPrice',
					key: maxPrice,
					value: maxPrice,
					identifier: `max_price_${maxPrice}`
				}
			]
		};
		dispatch(storeInitialItemInGlobalFilter(filteredState));
		onClose();
	};

	const onSelectSupplierType = (selectedData) => {
		setSelectedProductCategory(null);
		setSelectedSupplierType(selectedData);
		dispatch(
			fetchDependentFilterList({ type: 'SUPPLIER_LIST' }, { supplierType: selectedData[0]?.value })
		);
	};

	const COUNTERY_OPTIONS = [
		{
			value: 16,
			label: 'Bangladesh'
		},
		{
			value: 237,
			label: 'Turkey'
		},
		{
			value: 39,
			label: 'China'
		}
	];

	const handleCountryChange = (e, selectedCountryItem) => {
		const isChecked = e.target.checked;
		setSelectedCountry((prevSelectedCountry) => {
			if (isChecked) {
				return [
					...prevSelectedCountry,
					{ value: selectedCountryItem.value, label: selectedCountryItem.label }
				];
			} else {
				return prevSelectedCountry.filter((country) => country.value !== selectedCountryItem.value);
			}
		});
	};

	return (
		<ModalContainer>
			<div className="common-popup filter-quick-search-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Quick Search</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 mt-2">
							<div className="country-group custom-chekbox d-flex justify-content-start align-items-center">
								{COUNTERY_OPTIONS?.map((item) => (
									<div className="form-group" key={item.value}>
										<input
											type="checkbox"
											id={`country-${item.value}`}
											name="Country"
											value={item.value}
											checked={selectedCountry.some(
												(selected) => selected.value === item.value
											)}
											onChange={(e) => handleCountryChange(e, item)}
										/>
										<label className="regular-14" htmlFor={`country-${item.value}`}>
											<span>{item.label}</span>
										</label>
									</div>
								))}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group no-shadow-react-select size36">
								<label htmlFor="supplierType">Supplier type*</label>
								<CustomSelectableDropdown
									isMulti={false}
									allOptions={onGetData(dependentFilterList['supplierTypeList'])}
									setSelectedOptions={(value) => onSelectSupplierType(value)}
									selectedOptions={selectedSupplierType}
								/>
								{errors?.typeError && <p className="error">{errors?.typeError}</p>}
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group no-shadow-react-select size36">
								<label htmlFor="supplierType">Supplier Category</label>
								<CustomSelectableDropdown
									allOptions={onGetData(dependentFilterList['supplierCategoryList'])}
									setSelectedOptions={setSelectedFabricType}
									selectedOptions={selectedFabricType}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group no-shadow-react-select size36">
								<label htmlFor="productCategory">Product Category</label>
								<CustomSelectableDropdown
									isDisabled={['EMBELLISHMENT', 'WASHING']?.includes(
										selectedSupplierType[0]?.value
									)}
									allOptions={onGetData(
										dependentFilterList[
											categoryTypeBasedOnSupplierType[selectedSupplierType[0]?.value]
										]
									)}
									setSelectedOptions={setSelectedProductCategory}
									selectedOptions={selectedProductCategory}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor="minPrice">Price Range</label>
								<input
									type="text"
									name="minPrice"
									id="minPrice"
									placeholder="Min"
									value={minPrice}
									onChange={(e) => setMinPrice(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group size36">
								<label htmlFor="maxPrice" />
								<input
									type="text"
									name="maxPrice"
									id="maxPrice"
									placeholder="Max"
									value={maxPrice}
									onChange={(e) => setMaxPrice(e.target.value)}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group no-shadow-react-select size36">
								<label htmlFor="supplierType">Color type</label>
								<CustomSelectableDropdown
									isDisabled={selectedSupplierType[0]?.value !== 'FABRIC'}
									allOptions={onGetData(dependentFilterList['colorTypeList'])}
									setSelectedOptions={setColorType}
									selectedOptions={colorType}
								/>
							</div>
						</div>
						<div className="col-md-6">
							<div className="form-group no-shadow-react-select size36">
								<label htmlFor="supplierType">Brand</label>
								<CustomSelectableDropdown
									allOptions={onGetData(dependentFilterList['brandList'])}
									setSelectedOptions={setBrand}
									selectedOptions={brand}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" disabled={isLoading} onClick={handleSubmit}>
							Search
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default QuickFilterSupplier;
